import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { TimeField } from '../components/Table/fields/TimeField';
import { statuses } from './statuses';
import { service } from './service';
import { servicePackage } from './servicePackage';
import { serviceProvider } from './serviceProvider';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSelectWithOutAutocomplete } from '../components/Table/fields/SPSelectWithOutAutocompleteField';
import { FileField } from '../components/Table/fields/FileField';
import { CustomFields } from '../components/Custom/ServiceReservation/CustomFields';
import { userByRole } from './userByRole';
import { SPSelectUserField } from '../components/Table/fields/SPSelectUserField';

export const serviceReservationEdit: SchemaWithClient<any> = {
  name: 'Service Reservations View',
  pluralName: 'Service Reservations',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    service_reservation_status: {
      name: 'Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      switchboard: true,
      url: statuses.serviceReservationStatus.client.getAllPath,
      tempSchema: statuses.serviceReservationStatus,
      style: {
        marginBottom: '30px',
      },
    },

    system_configuration: {
      name: 'System Confirmation',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
      style: {},
    },
    files: {
      name: 'Manual Confirmation',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: FileField,
      fieldType: 'file',
      style: {
        marginBottom: '30px',
      },
    },
    /*
    group: {
      name: 'Group',
      fieldRenderer: SelectField.tableAdapter(group),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(group),
      url: group.client.getAllPath,
      tempSchema: group,
      switchboard: true,
      accordingTo: 'date',
      style: {
        background: '#256861',
        color: '#fff',
      },
    },*/
    size: {
      name: 'Group Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    service_package: {
      name: 'Service Group',
      fieldRenderer: SelectField.tableAdapter(servicePackage()),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(servicePackage()),
      url: servicePackage().client.getAllPath,
      tempSchema: servicePackage(),
      switchboard: true,
      accordingTo: 'activity_reservation',
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(serviceProvider),
      url: serviceProvider.client.getAllPath,
      tempSchema: serviceProvider,
      switchboard: true,
      accordingTo: 'activity_reservation',
    },
    selected_staff: {
      name: 'Event Staff',
      fieldRenderer: SelectField.tableAdapter(userByRole('9')),
      slidePaneFieldRenderer: SPSelectUserField.tableAdapter(userByRole('9')),
      url: userByRole('9').client.getAllPath,
      tempSchema: userByRole('9'),
      switchboard: true,
      accordingTo: 'activity_reservation',
    },
    service: {
      name: 'Service',
      fieldRenderer: SelectField.tableAdapter(service),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(service),
      url: service.client.getAllPath,
      tempSchema: service,
      switchboard: true,
      accordingTo: 'service_provider',
    },

    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    date: {
      name: 'Date',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    time: {
      name: 'Time',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },
    custom_fields: {
      name: 'Custom Fields',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: CustomFields,
      fieldType: 'custom',
      hideInTableView: true,
      withoutNameColumn: true,
    },

    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },

  client: new Client(`/service-reservations-view`),
};
